module.exports = __webpack_public_path__ + "static/media/columbia_getty_tablet.f04ad6a3.jpg";